module.exports = __webpack_public_path__ + "static/media/468x60_0056_ro.27c912c7.gif";